module.exports = __webpack_public_path__ + "img/logo_newyear.94caafcf.png";